(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ivori-recent-purchases-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const allowedCounts = Array.from({ length: 49 }, (_, i) => 101 + i)
      .filter(number => number % 10 !== 0);
    const windowMs = 12 * 60 * 60 * 1000;
    const key = 'ivori-recent-purchases:12h:' + location.pathname;
    const legacyKey = 'ivori-recent-purchases:' + location.pathname;
    let cached;
    let refreshTimer;

    const validState = (state, now) => state && allowedCounts.includes(state.count)
      && Number.isFinite(state.expiresAt) && state.expiresAt > now
      && state.expiresAt <= now + windowMs;

    const getState = () => {
      const now = Date.now();
      let saved = cached;
      try {
        const stored = JSON.parse(localStorage.getItem(key) || 'null');
        if (stored) saved = stored;
      } catch {}
      if (validState(saved, now)) return cached = saved;

      let count;
      if (!saved) {
        try {
          const legacy = JSON.parse(localStorage.getItem(legacyKey) || 'null');
          if (legacy && legacy.bucket === Math.floor(now / windowMs)
            && allowedCounts.includes(legacy.count)) count = legacy.count;
        } catch {}
      }
      if (!allowedCounts.includes(count)) {
        const choices = allowedCounts.filter(number => number !== saved?.count);
        count = choices[Math.floor(Math.random() * choices.length)];
      }
      cached = { count, expiresAt: now + windowMs };
      try {
        localStorage.setItem(key, JSON.stringify(cached));
      } catch {}
      return cached;
    };

    const showBadges = (scope = document) => {
      const badges = scope.querySelectorAll('[data-recent-badge]');
      if (!badges.length) return;
      const state = getState();

      badges.forEach(badge => {
        const countElement = badge.querySelector('[data-recent-count]');
        if (!countElement) return;
        countElement.textContent = state.count;
        badge.hidden = false;
      });
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => showBadges(), Math.max(1, state.expiresAt - Date.now()));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => showBadges(), { once: true });
    } else {
      showBadges();
    }
    document.addEventListener('shopify:section:load', event => showBadges(event.target));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) showBadges();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
